import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { SharedService } from '../helper/shared/shared.service';
import { LoginService } from '../login/login.service';
import { UserInfoService } from '../user-info/user-info.service';
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ProgramSettingsService {
  selUnit = this.userInfoService.userData.UserUnitId;
  selUnitName = this.userInfoService.userData.UserUnitName;
  selFormat = this.userInfoService.userData.NumberFormat;
  selConcUnitID = this.userInfoService.userData.UserConcUnitId;
  selConcUnit = this.userInfoService.userData.UserConcUnit;
  //selConcUnit:any;

  loginToken: string = "";
  progSettingData: any = {};
  currencyList: any;
  formatList: any;
  unitList: any;
  concUnitList: any;
  airFlowUnitList: any;
  airFlowUnit_SI: any;
  airFlowUnit_US: any;
  concUnit_SI: any;
  concUnit_US: any;
  //ApplyISAClass = 0;

  constructor(
    private httpService: HttpClient,
    private sharedService: SharedService,
    private loginService: LoginService,
    private userInfoService: UserInfoService
  ) {
    this.loginToken = this.loginService.cookieSvc.get("CFSSLoginCode");
  }

  //Modified by JW(2022-07-08): relocate Program Setting List to General.vb-start
  // getData(unitId:any): Observable<any> {
  //   let params = {
  //     'UnitID': unitId.toString(),
  //     'LoginCode': this.loginToken
  //   }
  //   return this.httpService.post(this.sharedService.applicationServiceUrl + 'MCCLDProgramSettingList', params);
  // }

  // postData(unitId:number, concId:number, formatId:number): Observable<any>{
  //   let params = {
  //     'UnitID': unitId,
  //     'ConcID': concId,
  //     'FormatNumber' : formatId,
  //     'LoginCode': this.loginToken,
  //     'UserID': this.userInfoService.userData.UserId,
  //     'ApplicationID': this.sharedService.ApplicationID
  //   }
  //   return this.httpService.post(this.sharedService.applicationServiceUrl + 'MCCLDSaveProgramSettings', params);
  // }

  getData(unitId: any): Observable<any> {
    let params = {
      'UnitID': unitId.toString(),
      'LoginCode': this.loginService.cookieSvc.get("CFSSLoginCode"),
      'RegionID': this.userInfoService.userData.RegionId,
      'CountryID': 0,
      'ApplicationID': this.sharedService.ApplicationID
    }
    return this.httpService.post(SharedService.applicationServiceUrl + SharedService.sService + 'RetrieveProgramSettingList', params);
  }
  //Modified by JW(2025-09-25): Azure DevOps #114732-start
  // postData(unitId: number, concId: number, formatId: number, airFlowUnit: string): Observable<any> { 
  //   let flowrate = airFlowUnit;
  //   let params = {
  //     'AppID': this.sharedService.ApplicationID,
  //     'UnitID': unitId,
  //     'LoginCode': this.loginService.cookieSvc.get("CFSSLoginCode"),
  //     'UserID': this.userInfoService.userData.UserId,
  //     'FormatCurrency': formatId,
  //     'FlowRate': flowrate,
  //     'ConcentrationID': concId
  //   }
  //   return this.httpService.post(SharedService.applicationServiceUrl + SharedService.sService + 'SaveProgramSettings', params);
  // }

  postData(unitId: number, concId: number, formatId: number, airFlowUnit: string): Observable<any> {
    const api = 'SaveProgramSettings';
    let flowrate = airFlowUnit;
    let params = {
      'AppID': this.sharedService.ApplicationID,
      'UnitID': unitId,
      'LoginCode': this.loginService.cookieSvc.get("CFSSLoginCode"),
      'UserID': this.userInfoService.userData.UserId,
      'FormatCurrency': formatId,
      'FlowRate': flowrate,
      'ConcentrationID': concId
    }
    const urlTieto = `${SharedService.applicationServiceUrl_Tieto}${api}`;
    const urlAzure = `${SharedService.applicationServiceUrl}${SharedService.sService}${api}`;
    const safePost = (url: string) =>
      this.httpService.post(url, params).pipe(
        catchError(err => of({ error: true, url, details: err }))
      );

    return forkJoin({
      tieto: safePost(urlTieto),
      azure: safePost(urlAzure)
    });
  }
  //Modified by JW(2025-09-25): Azure DevOps #114732-end

  //Modified by JW(2022-07-08): relocate Program Setting List to General.vb-end

  getSelectedConcId(desc: string) {
    desc = desc.trim();
    let concId = 2;
    if (desc === 'ppb') {
      concId = 1;
    }
    return concId;
  }

  getSelectedFormatId(desc: string) {
    desc = desc.trim();
    let formatId = 0;
    switch (desc) {
      case this.sharedService.FormatDesc_SI:
        formatId = 1;
        break;
      case this.sharedService.FormatDesc_US:
        formatId = 2;
        break;
    }
    return formatId;
  }
}
